import type { PropsWithChildren } from "react";
import { Theme } from "@carbon/react";
import { Background } from "../../components";

import styles from "./Layout.module.scss";

const Layout = ({ children }: PropsWithChildren) => (
  <div className={styles.layout}>
    <Background />
    <div className={styles.layout__foreground}>
      <Theme theme="white" className={styles.layout__foreground__themed}>
        <div className={styles.layout__foreground__themed__content}>{children}</div>
      </Theme>
    </div>
  </div>
);

export default Layout;
